import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-91d21ffa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "mid-container" }
const _hoisted_3 = { class: "customer-detail-section" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Case Study", -1))
const _hoisted_6 = { class: "customer-detail-inner" }
const _hoisted_7 = { class: "customer-detail-sidebar" }
const _hoisted_8 = { class: "customer-logo" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "short-details" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "related-case-study" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Related Case Studies", -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "customer-detail-content" }
const _hoisted_18 = { class: "c_d_des" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "case-study-slider" }
const _hoisted_21 = {
  id: "carouselExampleIndicators",
  class: "carousel slide",
  "data-bs-ride": "carousel"
}
const _hoisted_22 = { class: "carousel-inner" }
const _hoisted_23 = { class: "carousel-item active" }
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = { class: "case-study-tabs" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "case-study-tabs--top" }, [
  /*#__PURE__*/_createElementVNode("ul", {
    class: "nav",
    id: "myTab",
    role: "tablist"
  }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "active",
        id: "tab-a",
        "data-bs-toggle": "tab",
        href: "#taba",
        role: "tab",
        "aria-controls": "taba",
        "aria-selected": "true"
      }, "Challenge")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        id: "tab-b",
        "data-bs-toggle": "tab",
        href: "#tabb",
        role: "tab",
        "aria-controls": "tabb",
        "aria-selected": "false"
      }, "Solutions")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        id: "tab-c",
        "data-bs-toggle": "tab",
        href: "#tabc",
        role: "tab",
        "aria-controls": "tabc",
        "aria-selected": "false"
      }, "Result")
    ])
  ])
], -1))
const _hoisted_27 = {
  class: "case-study-tabs--btm tab-content",
  id: "myTabContent"
}
const _hoisted_28 = {
  class: "tab-pane fade show active",
  id: "taba",
  role: "tabpanel",
  "aria-labelledby": "tab-a"
}
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = {
  class: "tab-pane fade",
  id: "tabb",
  role: "tabpanel",
  "aria-labelledby": "tab-b"
}
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = {
  class: "tab-pane fade",
  id: "tabc",
  role: "tabpanel",
  "aria-labelledby": "tab-c"
}
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_userHeader = _resolveComponent("userHeader")!
  const _component_userFooter = _resolveComponent("userFooter")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_userHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: _ctx.getCdnImageAddress(_ctx.clientData.companyLogo, `w_248,h_202/`),
                  alt: _ctx.clientData.title
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", { innerHTML: _ctx.truncatedDescription }, null, 8, _hoisted_11)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedCaseStudies, (relatedClient) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: relatedClient.id
                    }, [
                      (_ctx.shouldShowClientReadMore(relatedClient))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.navigateToClient(relatedClient.slug)), ["prevent"])
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.getCdnImageAddress(relatedClient.companyLogo, `w_120,h_98/`),
                                alt: relatedClient.title
                              }, null, 8, _hoisted_16)
                            ], 8, _hoisted_15)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.clientData.title), 1),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("p", {
                  innerHTML: _ctx.clientData.description
                }, null, 8, _hoisted_19)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("img", {
                        src: _ctx.getCdnImageAddress(_ctx.clientData.companyImage, `w_719,h_429/`),
                        alt: _ctx.clientData.title
                      }, null, 8, _hoisted_24)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("p", {
                      innerHTML: _ctx.clientData.challenge
                    }, null, 8, _hoisted_29)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("p", {
                      innerHTML: _ctx.clientData.solution
                    }, null, 8, _hoisted_31)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("p", {
                      innerHTML: _ctx.clientData.result
                    }, null, 8, _hoisted_33)
                  ])
                ])
              ])
            ]),
            _hoisted_34
          ])
        ])
      ])
    ]),
    _createVNode(_component_userFooter)
  ]))
}